 <!-- <div class="opinion-wrapper" *ngIf="!pollAnswer">
 	<div class="ow-text">{{poll.title}}</div>
 	<div class="ow-question">{{poll.description}}</div>
 	<div class="ow-answers">
 		<a *ngFor="let option of poll.answers" class="ow-answers-link" (click)="answer(option)"><img src="{{option.image}}" class="ow-answers-smile" alt=""></a>
 	</div>
 	<img src="" alt="" class="brand-logo">
 </div>

 <div *ngIf="pollAnswer">
	<div class="opinion-wrapper">
		<div class="ow-thanks-title">{{getAnswerTitle()}}</div>
		<div class="ow-thanks-text">{{getAnswerDescription()}}</div>
		<a class="btn btn-thanks" (click)="gotoIdle()">Done</a>
 		<img src="" alt="" class="brand-logo">
	</div>
</div> -->

<div>
    <div class="opinion-wrapper">
		<div></div>
		<div>
			<div class="ow-thanks-title">titulo 1</div>
			<div class="ow-thanks-text">Titulo 2</div>
			<!-- <a class="btn btn-thanks" (click)="gotoIdle()">Done</a> -->
		</div>
		<img src="" alt="" class="brand-logo">
   </div>
</div>